import React, { Component } from 'react';
import { connect } from "react-redux";
import _ from 'lodash'
import { fetchUsers, deleteUser} from '../../../actions';
import { approveClient } from '../../../actions/admin';
import Pagination from '../../common/Pagination'
import ModalConfirm from '../../common/ModalConfirm'
import Table from './Table'

class Clients extends Component{
    constructor(props) {
        super(props);
        this.state = {
            page: 1,
            sort: "created_at",
            order: "desc",
            q: null,
            filter: null,
            showApproved: true,
            casoToArchive: null,
            activateCaso: false,
            showDeleteModal: false,
            dataDeleteModal: null
        };
    }
    componentDidMount() {
        const {sort, order} = this.state
        this.props.fetchUsers(sort, order, null, 1, 1);
    }
    componentDidUpdate(prevProps, prevState){
        if(prevState === this.state) return false
        if(prevState.showDeleteModal !== this.state.showDeleteModal) return false

        const {sort, order, q, page, filter, showApproved} = this.state
        const approved = showApproved ? 1 : 0;
        this.props.fetchUsers(sort, order, q, page, approved);
    }
    removeCaso(caso){
        this.props.removeCaso(caso);
    }
    changePage(e){
        e.preventDefault();
        console.log(e.target.id);
        this.setState({ page: e.target.id})
    }
    filterList(e){
        let q = e.target.value.toLowerCase()
        this.setState({ q, page: 1 })
    }
    clearQ(){
        this.setState({q: null, page: 1})
    }
    applyFilter(f){
        let filter = f;
        this.setState({ filter, page: 1 })
    }
    applyOrder(sort, order){
        this.setState({
            sort,
            order
        })
    }
    toggleModal() {
        this.setState({
            showDeleteModal: !this.state.showDeleteModal
        })
    }
    deleteClient(data){
        this.setState({dataDeleteModal: data})
        this.toggleModal(data)
    }
    render(){
        return(
            <div className="justify-content-md-center">
                <div className="col-md-12 content-container">
                    <div className="filter-area">
                        <form className="form-inline form-filter" style={{width:"20%"}}>
                            <input
                                style={{width: "100%"}}
                                className="form-control"
                                type="search"
                                placeholder="Buscar cliente"
                                aria-label="Search"
                                value={this.state.q || ""}
                                onChange={this.filterList.bind(this)}
                            />
                            {this.state.q && <span
                                className="form-control-clear"
                                onClick={this.clearQ.bind(this)}>
                                    <i className="fa fa-close" />
                            </span>}
                        </form>
                        <div className="switcher">
                            <label className="switch switch-default switch-pill switch-success form-control-label">
                                <input type="checkbox"
                                       className="switch-input form-check-input"
                                       checked={this.state.showApproved}
                                       value={this.state.showApproved}
                                       onChange={()=>{
                                           this.setState({showApproved: !this.state.showApproved})
                                       }}
                                />
                                <span className="switch-label"></span><span className="switch-handle"></span>
                            </label>
                            Pendientes de aprobación
                        </div>
                        <br className="clearfix" />
                    </div>
                    <Table
                        clients={this.props.clients}
                        applyOrder={this.applyOrder.bind(this)}
                        sort={this.state.sort}
                        order={this.state.order}
                        approveClient={this.props.approveClient.bind(this)}
                        deleteClient={this.deleteClient.bind(this)}
                    />
                    {this.props.pagination.last_page > 1 && <Pagination
                        data={this.props.pagination}
                        state={this.state}
                        changePage={this.changePage.bind(this)}
                    />}
                </div>
                <ModalConfirm
                    isOpen={this.state.showDeleteModal}
                    toggler={this.toggleModal.bind(this)}
                    data={this.state.dataDeleteModal}
                    action={this.props.deleteUser.bind(this)}
                    title="Borrar cliente"
                    message="Borrar el cliente borrará todos los datos, casos y adjuntos pertenecientes al usuario."
                    button="Borrar"
                />
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
        clients: state.clients.data,
        pagination: _.omit(state.clients, "data")
    };
}
export default connect(mapStateToProps, { fetchUsers, deleteUser, approveClient })(Clients);


// WEBPACK FOOTER //
// ./resources/assets/js/components/admin/clients/Clients.jsx